import T from 'prop-types'
import React from 'react'
import ListInput from './ListInput'
import {
  validatePort
} from 'pw-validators'

export default class extends React.Component {
  static displayName = 'PortListInput'

  static propTypes = {
    className: T.string,
    initialValue: T.string,
    onChange: T.func,
    allowDuplicates: T.bool,
    typeaheadOptions: T.arrayOf(T.string)
  }

  static defaultProps = {
  }

  resetToInitialValue = () => {
    if (this._editor) {
      this._editor.resetToInitialValue()
    }
  }

  _handleEditorRef = (inst) => {
    this._editor = inst
  }

  render() {
    return (
      <ListInput
        lineClassName={ `port_list_item` }
        lineLabel={ "Port" }
        lineValidator={ validatePort }
        placeholder={ `3000`}
        ref={ this._handleEditorRef }
        { ...this.props }
      />
    )
  }
}
